import React, { PropTypes } from 'react';
import FullScreenOverlay from '@bibliocommons/base-full-screen-overlay';
import { childrenShape } from '@bibliocommons/bc-prop-types';

import './BorrowingBatchActionsOverlay.scss';

export default function BorrowingBatchActionsOverlay({ className, open, handleClose, header, subtitle, children, footer }) {
  return (
    <FullScreenOverlay
      className={`cp-borrowing-batch-actions-overlay ${className}`}
      disableHistoryControls
      open={open}
      handleClose={handleClose}>
      {header && <h2 className={`overlay-header ${className}`}> {header} </h2>}
      {subtitle && <div className={`overlay-subtitle ${className}`}> {subtitle} </div>}
      <div className={`overlay-content ${className}`}>
        {children}
      </div>
      <hr />
      {footer && <div className="overlay-footer clearfix">{footer}</div>}
    </FullScreenOverlay>
  );
}

BorrowingBatchActionsOverlay.propTypes = {
  open: PropTypes.bool.isRequired,
  className: PropTypes.string,
  handleClose: PropTypes.func,
  header: PropTypes.node,
  subtitle: PropTypes.node,
  children: childrenShape,
  footer: PropTypes.node
};



// WEBPACK FOOTER //
// ./app/components/borrowing/shared/BorrowingBatchActionsOverlay/BorrowingBatchActionsOverlay.jsx